"use client";

import React from "react";
import { MapPin, Phone, Mail, Clock } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function TerritorioHistorico() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="223055" id="worldwide-presence" className="bg-background text-foreground relative w-full h-[650px] lg:h-[750px] overflow-hidden">
      {}
      <div className="absolute inset-0 w-full h-full bg-black">
        <iframe title="Global Performance Map" src="https://www.openstreetmap.org/export/embed.html?bbox=-180%2C-60%2C180%2C80&amp;layer=mapnik" className="w-full h-full border-0 opacity-60" style={{
        filter: "invert(100%) hue-rotate(180deg) brightness(40%) contrast(150%) grayscale(100%)"
      }} allowFullScreen loading="lazy"></iframe>
        {}
        <div className="absolute inset-0 bg-black/60 pointer-events-none mix-blend-multiply"></div>
      </div>

      {}
      <div className="relative z-10 container mx-auto px-4 md:px-8 h-full flex items-center justify-start">
        <div ref={ref} className={`w-full max-w-md transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-12"}`}>
          <Card className="bg-card/90 backdrop-blur-xl border-border/50 shadow-4xl rounded-md">
            <CardHeader className="pb-4 pt-8">
              <CardTitle className="font-default text-3xl font-bold text-foreground border-b border-primary/20 pb-4 tracking-wider uppercase">
                Global HQ
              </CardTitle>
            </CardHeader>
            <CardContent className="flex flex-col gap-6 pb-8">
              <div className="flex items-start gap-4 text-foreground">
                <div className="bg-primary/10 p-2 rounded-md shrink-0">
                  <MapPin className="w-5 h-5 text-primary" />
                </div>
                <div>
                  <h4 className="font-default font-semibold text-primary text-sm uppercase tracking-widest mb-1">
                    Location
                  </h4>
                  <p className="text-muted-foreground font-sans">International&nbsp;</p>
                </div>
              </div>

              <div className="flex items-start gap-4 text-foreground">
                <div className="bg-primary/10 p-2 rounded-md shrink-0">
                  <Phone className="w-5 h-5 text-primary" />
                </div>
                <div>
                  <h4 className="font-default font-semibold text-primary text-sm uppercase tracking-widest mb-1">
                    Booking Line
                  </h4>
                  <p className="text-muted-foreground font-sans">+1 702 366 6739 - +598 96 635 300</p>
                </div>
              </div>

              

              <div className="flex items-start gap-4 text-foreground">
                <div className="bg-primary/10 p-2 rounded-md shrink-0">
                  <Clock className="w-5 h-5 text-primary" />
                </div>
                <div>
                  <h4 className="font-default font-semibold text-primary text-sm uppercase tracking-widest mb-1">
                    Studio Hours
                  </h4>
                  <p className="text-muted-foreground font-sans">24/7 Global Support</p>
                </div>
              </div>

              <div className="flex flex-col sm:flex-row gap-4 mt-6">
                <Button asChild className="flex-1 bg-primary hover:bg-primary/90 text-primary-foreground rounded-md h-14 text-lg font-default shadow-lg transition-all duration-300 uppercase tracking-widest">
                  <Link to="/GlobalStagesPage">Reserva Viaje<br /></Link>
                </Button>
                <Button asChild className="flex-1 bg-primary hover:bg-primary/90 text-primary-foreground rounded-md h-14 text-lg font-default shadow-lg transition-all duration-300 uppercase tracking-widest">
                  <Link to="/GlobalStagesPage">Book Talent</Link>
                </Button>
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    </section>;
}